export const APP_COLUMN_CONTAINER = {
  "Column.Container.Flex.Direction": {
    defaultValue: "row"
  },
  "Column.Container.Flex.Wrap": {
    defaultValue: "wrap"
  },
  "Column.Container.Row.Gap": {
    defaultValue: "0px"
  },
  "Column.Container.Column.Gap": {
    defaultValue: "0px"
  },
  "Column.Container.Width": {
    defaultValue: "50%"
  },
  "Column.Container.Min.Width": {
    defaultValue: "unset"
  },
  "Column.Container.Margin.Top": {
    defaultValue: "0px"
  },
  "Column.Container.Margin.Right": {
    defaultValue: "0px"
  },
  "Column.Container.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Column.Container.Margin.Left": {
    defaultValue: "0px"
  },
  "Column.Container.Padding.Top": {
    defaultValue: "0px"
  },
  "Column.Container.Padding.Right": {
    defaultValue: "0px"
  },
  "Column.Container.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Column.Container.Padding.Left": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Color": {
    ref: "Color.Black"
  },
  "Column.Container.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Column.Container.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Column.Container.Height": {
    defaultValue: "auto"
  },
  "Column.Container.Overflow": {
    defaultValue: "auto"
  },
  "Column.Container.Align.Items": {
    defaultValue: "flex-start"
  },
  "Column.Container.Justify.Content": {
    defaultValue: "flex-start"
  },
  "Column.Container.Align.Content": {
    defaultValue: "flex-start"
  },
  "Column.Container.Display": {
    defaultValue: "flex"
  },
  "Column.Container.Min.Height": {
    defaultValue: "unset"
  },
  "Column.Container.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Column.Container.Background.Color": {
    ref: "Color.Transparent"
  },
  "Column.Container.Background": {
    ref: "Color.Transparent"
  },
  "Column.Container.Border.Style": {
    defaultValue: "solid"
  },
  "Column.Container.Max.Height": {
    defaultValue: "unset"
  },
  "Column.Container.Max.Width": {
    defaultValue: "unset"
  },
  "Column.Container.Box.Shadow": {
    defaultValue: "none"
  }
};
